import axios from 'axios/lib/axios';

const base = '/api/v1/';
const timeout = 30000;

const endpoints = {
  getPreferences: function () {
    return axios.get(`${base}mypreferences`, {
      timeout: timeout,
    });
  },
  createPreferences: function (data) {
    return axios.post(`${base}mypreferences`, data, {
      timeout: timeout,
    });
  },
  createOrUpdateViewIndicator: function (data) {
    return axios.put(`${base}view-indicators`, data, {
      timeout: timeout,
    });
  },
};

export default endpoints;
